export default __webpack_public_path__ + "static/media/success-check.d42a1a8c.svg";